import { createPolicy } from "../policy";
import { evaluateRoleRequirement } from "../role";

/** 管理者（ADMINISTRATOR）以上に限定する基本ポリシーです。 */
export const adminOrAbovePolicy = createPolicy((context) =>
  evaluateRoleRequirement(context.currentUser.role, {
    atLeast: "ADMINISTRATOR",
  }),
);

/** オーナー（OWNER）のみを許可する基本ポリシーです。 */
export const ownerOnlyPolicy = createPolicy((context) =>
  evaluateRoleRequirement(context.currentUser.role, { require: "OWNER" }),
);

/** オーナーまたは管理者（ADMINISTRATOR）を許可する基本ポリシーです。 */
export const ownerOrAdminPolicy = createPolicy((context) =>
  evaluateRoleRequirement(context.currentUser.role, {
    require: ["OWNER", "ADMINISTRATOR"],
  }),
);

/** 編集者（FULL_MEMBER）以上に許可を拡張する基本ポリシーです。 */
export const editorOrAbovePolicy = createPolicy((context) =>
  evaluateRoleRequirement(context.currentUser.role, { atLeast: "FULL_MEMBER" }),
);
